export const sleep = (delay: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, delay))

export function resolveAfterTimeout<T>(
  promise: Promise<T> | T,
  delay: number
): Promise<T | void> {
  return Promise.race([promise, sleep(delay)])
}
